import { Link, useNavigate } from 'react-router';
import Description from '@/components/elements/Description';
import Icon from '@/components/elements/Icon/Icon';
import LogoWhite from '@/assets/images/logo/logo-white.svg';
// import { X } from '@/assets/icons/X';
//import { LinkedIn } from '@/assets/icons/LinkedIn';
//import { Facebook } from '@/assets/icons/Facebook';
export const Footer = () => {
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate();

    const handleLogoClick = () => {
        navigate('/');
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    };

    return (
        <footer className="mt-auto w-full overflow-hidden bg-[#004785] p-5 md:p-10 lg:p-20">
            <div className="container mx-auto px-4">
                <div className="flex w-full flex-wrap items-center justify-between gap-8 lg:gap-[40px_100px]">
                    <div
                        className="my-auto flex w-auto items-stretch gap-2.5 self-stretch text-center text-[10px] leading-[1.2] font-semibold tracking-[-0.2px] whitespace-nowrap text-white lg:w-[292px] cursor-pointer"
                        onClick={handleLogoClick}
                    >
                        <Icon src={LogoWhite} className="logo w-full text-white" />
                    </div>

                    {/* <div className="my-auto flex gap-4 self-stretch">
                        <Link
                            to="#"
                            className="flex h-6 w-6 items-center justify-center transition-opacity hover:opacity-80"
                            aria-label="LinkedIn"
                        >
                            <LinkedIn />
                        </Link>
                        <Link
                            to="#"
                            className="flex h-6 w-6 items-center justify-center transition-opacity hover:opacity-80"
                            aria-label="Twitter"
                        >
                            <X />
                        </Link>
                        <Link
                            to="#"
                            className="flex h-6 w-6 items-center justify-center transition-opacity hover:opacity-80"
                            aria-label="Facebook"
                        >
                            <Facebook />
                        </Link>
                    </div> */}
                </div>

                <div className="mt-6 min-h-px w-full border border-solid border-[#FFFFFF33] bg-[#FFFFFF33]" />

                <div className="mt-6 flex w-full flex-col gap-8 leading-[1.2] text-white md:flex-row md:justify-between lg:flex lg:justify-between lg:gap-[40px_100px]">
                    <div className="w-full text-sm leading-[19px] font-normal md:w-auto md:text-base lg:w-[292px] lg:shrink-0">
                        <Description
                            description="The comprehensive ICHRA platform for brokers, carriers, and TPAs. Build your brand, control your
                        pricing, and grow your business."
                            type="small"
                            className="w-full max-w-full text-white md:max-w-[281px] lg:max-w-[292px]"
                        />
                    </div>

                    <div className="grid w-full grid-cols-2 gap-8 lg:grid-cols-4 lg:w-full lg:gap-6 xl:gap-8">
                        {/* <nav className="w-full min-w-0">
                            <h3 className="text-lg font-semibold text-white md:text-xl">Customers</h3>
                            <div className="mt-4 flex flex-col gap-3 text-sm font-normal">
                                <Link
                                    to="/use-cases/brokers"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    Brokers
                                </Link>
                                <Link to="/demo" className="text-white transition-colors hover:text-[#0077DF]">
                                    Carriers
                                </Link>
                                <Link
                                    to="/use-cases/tpas-third-party-administrators"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    TPAs
                                </Link>
                            </div>
                        </nav> */}

                        <nav className="w-full min-w-0">
                            <h3 className="text-lg font-semibold text-white md:text-xl">Product</h3>
                            <div className="mt-4 flex flex-col gap-3 text-sm font-normal">
                                <Link
                                    to="/shop-individual-health-insurance-plans"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    Shop Plans
                                </Link>
                                <Link to="/pricing" className="text-white transition-colors hover:text-[#0077DF]">
                                    Pricing
                                </Link>
                            </div>
                        </nav>

                        <nav className="w-full min-w-0">
                            <h3 className="text-lg font-semibold text-white md:text-xl">Use Cases</h3>
                            <div className="mt-4 flex flex-col gap-3 text-sm font-normal">

                                <Link
                                    to="/use-cases/brokers"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    Brokers
                                </Link>
                                <Link
                                    to="/use-cases/general-agents"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    General Agents
                                </Link>
                                <Link to="/use-cases/fmos" className="text-white transition-colors hover:text-[#0077DF]">
                                    FMOs
                                </Link>
                                <Link
                                    to="/use-cases/peos-payroll-employment-organizations"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    PEOs
                                </Link>

                                <Link
                                    to="/use-cases/tpas-third-party-administrators"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    TPAs
                                </Link>

                            </div>
                        </nav>

                        <nav className="w-full min-w-0">
                            <h3 className="text-lg font-semibold text-white md:text-xl">Company</h3>
                            <div className="mt-4 flex flex-col gap-3 text-sm font-normal">
                                <Link
                                    to="/company/overview"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    Overview
                                </Link>
                                <Link
                                    to="/company/founders"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    Founders
                                </Link>
                                <Link
                                    to="/advisory-board"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    Advisory Board
                                </Link>
                                <Link to="/press" className="text-white transition-colors hover:text-[#0077DF]">
                                    Press
                                </Link>
                            </div>
                        </nav>

                        <nav className="w-full min-w-0">
                            <h3 className="text-lg font-semibold text-white md:text-xl">Contact</h3>
                            <div className="mt-4 flex flex-col gap-3 text-sm font-normal">

                                <Link to="/contact-us" className="text-white transition-colors hover:text-[#0077DF]">
                                    Contact Us
                                </Link>
                                <Link
                                    to="tel:+1-888-777-8190"
                                    className="text-white transition-colors hover:text-[#0077DF]"
                                >
                                    +1-888-777-8190
                                </Link>
                            </div>
                        </nav>
                    </div>
                </div>

                <div className="mt-6 min-h-px w-full border border-solid border-[#FFFFFF33] bg-[#FFFFFF33]" />

                <div className="mt-6 flex flex-col gap-4 text-sm leading-[1.2] font-normal text-[#FFFFFF99] md:flex-row md:items-center md:justify-between md:text-base">
                    {/* Mobile: Copyright on top, full width */}
                    <p className="text-center text-base w-full md:w-auto md:order-2">© {currentYear} Predictable Benefits. All rights reserved.</p>

                    {/* Mobile: Privacy Policy and Terms of Use below, side by side */}
                    <div className="flex w-full items-center justify-between md:hidden">
                        <Link
                            to="/privacy"
                            className="text-base transition-colors hover:text-[#0077DF]"
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            to="/terms"
                            className="text-base transition-colors hover:text-[#0077DF]"
                        >
                            Terms of Use
                        </Link>
                    </div>

                    {/* Desktop/Tablet: Privacy Policy on left */}
                    <Link
                        to="/privacy"
                        className="hidden text-base transition-colors hover:text-[#0077DF] md:block md:order-1"
                    >
                        Privacy Policy
                    </Link>

                    {/* Desktop/Tablet: Terms of Use on right */}
                    <Link
                        to="/terms"
                        className="hidden text-base transition-colors hover:text-[#0077DF] md:block md:order-3"
                    >
                        Terms of Use
                    </Link>
                </div>
            </div>
        </footer>
    );
};
